export interface HqAssignmentParsed {
  hqAssignmentType: 'platform' | 'platform_node' | null;
  hqAssignmentId: string | null;
}

/**
 * Parses an HQ assignment value into type and ID components
 * @param hqAssignmentValue - The combined assignment value (e.g., "platform_123" or "platform_node_456")
 * @returns Object with hqAssignmentType and hqAssignmentId
 */
export const parseHqAssignmentValue = (
  hqAssignmentValue: string
): HqAssignmentParsed => {
  let hqAssignmentType: 'platform' | 'platform_node' | null = null;
  let hqAssignmentId: string | null = null;

  if (hqAssignmentValue) {
    // Handle two formats: "platform_123" or "platform_node_456"
    if (hqAssignmentValue.startsWith('platform_node_')) {
      hqAssignmentType = 'platform_node';
      hqAssignmentId = hqAssignmentValue.replace('platform_node_', '');
    } else if (hqAssignmentValue.startsWith('platform_')) {
      hqAssignmentType = 'platform';
      hqAssignmentId = hqAssignmentValue.replace('platform_', '');
    }
  }

  return { hqAssignmentType, hqAssignmentId };
};
